export const TID = {
  // header / nav
  logo: "brand-logo",
  navItem: (s) => `nav-item-${s}`,
  searchOpen: "utility-search",
  account: "utility-account",
  saved: "utility-saved",
  bag: "utility-bag",
  mobileMenu: "mobile-menu-toggle",
  announcement: "announcement-bar",
  // product
  productCard: (s) => `product-card-${s}`,
  addToBag: "add-to-bag-button",
  colourSwatch: (n) => `colour-swatch-${n}`,
  sizeOption: (n) => `size-option-${n}`,
  saveToggle: "save-piece-toggle",
  // bag
  bagDrawer: "bag-drawer",
  bagCheckout: "bag-checkout",
  bagContinue: "bag-continue",
  bagRemove: (i) => `bag-remove-${i}`,
  // music
  musicToggle: "music-toggle",
  musicPlayPause: "music-play-pause",
  musicMute: "music-mute",
  // search
  searchInput: "search-input",
  // newsletter
  newsletterEmail: "newsletter-email",
  newsletterSubmit: "newsletter-submit",
  // admin
  adminEmail: "admin-email",
  adminPassword: "admin-password",
  adminLogin: "admin-login-submit",
  adminNav: (s) => `admin-nav-${s}`,
  adminSave: "admin-save",
};
